import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditCoupon from "../../components/coupons/FormAddEditCoupon";

const CreateCoupon = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/coupons");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditCoupon
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateCoupon;
